import PropTypes from "prop-types";

import { ListItem } from "@features/ui";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { roundToNearestIncrement } from "@lib/app.helpers";
import "./institution-item.scss";

export const InstitutionItem = ({
  index,
  institution,
  showPrograms,
  onClick,
}) => {
  const isLink = !!onClick;
  const linkIcon = institution.webAddr ? (
    <FontAwesomeIcon
      className="list-item-icon"
      icon={["fasr", "arrow-up-right-from-square"]}
    />
  ) : undefined;

  return (
    <ListItem
      key={institution.name}
      role="link"
      interactive={isLink}
      className="institution-item"
      index={index + 1}
      icon={isLink ? linkIcon : false}
      onClick={isLink ? () => onClick(institution) : undefined}
    >
      <div className="header">
        <span>{institution.name}</span>
      </div>
      {showPrograms &&
        (institution.programs ?? []).map((program) => (
          <div className="description" key={program}>
            {program}
          </div>
        ))}
      <div className="distance">
        <FontAwesomeIcon icon={["fa-regular", "map-pin"]} />
        &nbsp;Less than&nbsp;
        {roundToNearestIncrement(institution.distanceMiles, 5, {
          // round up to nearest 5-mile increment
          roundingModifier: Math.ceil,
        })}
        &nbsp;miles from me
      </div>
      {isLink && <span className="a11y-only">Opens in new tab</span>}
    </ListItem>
  );
};

InstitutionItem.propTypes = {
  index: PropTypes.number,
  institution: PropTypes.shape({
    name: PropTypes.string,
    distanceMiles: PropTypes.number,
    webAddr: PropTypes.string,
    programs: PropTypes.arrayOf(PropTypes.string),
  }),
  showPrograms: PropTypes.bool,
  onClick: PropTypes.func,
};
